import { WidgetCheckoutOptimizationConfigSchema } from "@redotech/redo-model/checkouts/widget";
import { z } from "zod/v4";

export const getCheckoutOptimizationConfig = {
  input: z.object({
    /**
     * The store URL that is passed as a request header is the one that will
     * determine the team in the handler's context. That team should be used
     * if the team is needed.
     *
     * This param is unused, but still needs to be here for cache routing.
     */
    storeUrl_forCacheRoutingOnly: z.string(),
  }),
  output: WidgetCheckoutOptimizationConfigSchema,
};
